import Marquee from "react-fast-marquee";

// Slow editorial marquee with large stroked text.
export const EditorialMarquee = ({ words = ["SPEED", "PRECISION", "ADRENALINE", "GRIP"], speed = 30 }) => {
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-[#0A0A0A] py-8 md:py-12">
      <Marquee speed={speed} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="mx-8 flex items-center font-display text-6xl tracking-tight text-stroke md:text-8xl">
            {w}
            <span className="mx-8 inline-block h-3 w-3 rounded-full bg-kbyellow align-middle" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export const TextTicker = ({ text = "ARRIVE · SIGN · GEAR UP · RACE ·", speed = 45, color = "text-black", bg = "bg-kbyellow" }) => {
  return (
    <div className={`overflow-hidden ${bg} py-3`}>
      <Marquee speed={speed} gradient={false} autoFill>
        <span className={`mx-4 font-display text-xl tracking-widest ${color}`}>{text}</span>
      </Marquee>
    </div>
  );
};

export default EditorialMarquee;
